/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Hide_Track_2Inputs */

const en_event_group_options_hide_track_2 = /** @type {(inputs: Event_Group_Options_Hide_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide Track 2`)
};

const fr_event_group_options_hide_track_2 = /** @type {(inputs: Event_Group_Options_Hide_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer la piste 2`)
};

const de_event_group_options_hide_track_2 = /** @type {(inputs: Event_Group_Options_Hide_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spur 2 ausblenden`)
};

const it_event_group_options_hide_track_2 = /** @type {(inputs: Event_Group_Options_Hide_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi traccia 2`)
};

const ru_event_group_options_hide_track_2 = /** @type {(inputs: Event_Group_Options_Hide_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть трек 2`)
};

const es_event_group_options_hide_track_2 = /** @type {(inputs: Event_Group_Options_Hide_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar pista 2`)
};

const zh_cn2_event_group_options_hide_track_2 = /** @type {(inputs: Event_Group_Options_Hide_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏曲目 2`)
};

const ja_event_group_options_hide_track_2 = /** @type {(inputs: Event_Group_Options_Hide_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラック2を非表示`)
};

const hi_event_group_options_hide_track_2 = /** @type {(inputs: Event_Group_Options_Hide_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक 2 छुपाएँ`)
};

const pt_pt2_event_group_options_hide_track_2 = /** @type {(inputs: Event_Group_Options_Hide_Track_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar faixa 2`)
};

/**
* | output |
* | --- |
* | "Hide Track 2" |
*
* @param {Event_Group_Options_Hide_Track_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_hide_track_2 = /** @type {((inputs?: Event_Group_Options_Hide_Track_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Hide_Track_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_hide_track_2(inputs)
	if (locale === "de") return de_event_group_options_hide_track_2(inputs)
	if (locale === "it") return it_event_group_options_hide_track_2(inputs)
	if (locale === "ru") return ru_event_group_options_hide_track_2(inputs)
	if (locale === "es") return es_event_group_options_hide_track_2(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_hide_track_2(inputs)
	if (locale === "ja") return ja_event_group_options_hide_track_2(inputs)
	if (locale === "hi") return hi_event_group_options_hide_track_2(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_hide_track_2(inputs)
	return en_event_group_options_hide_track_2(inputs)
});